module.exports = "<disqus [identifier]=\"'freyes'\"></disqus>\n<!-- <div id=\"disqus_thread\"></div> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/blog/disqus/disqus.component.html
// module id = ./src/app/components/blog/disqus/disqus.component.html
// module chunks = main